import { useEffect, useRef, useState } from 'react';
import Overlay from '../../ui/Overlay';

import { createBounty, getBounty } from '../../apis/bounties/bounties';

import ModalBox from '../../ui/ModalBox';
import { sanitizeBountyData } from '../../helpers/sanitizeBountyDetails';
import { useLoadingState } from '../../hooks/useLoader';
import { toast } from 'sonner';
import Loader from '../../ui/Loader';
import { ArrowRight } from 'lucide-react';
import Button from '../../ui/Button';
import { useHome } from '../../contexts/HomeContext';

function PrimaryPillConfirmation({ close, foundPill, handleConfirmAction, extraIPs }) {
    const modalRef = useRef(null); // Reference for the modal content
    const { loading, startLoading, stopLoading } = useLoadingState();
    const { state: homeState, dispatch, gettingGreenpillCounts, putSelectedPill } = useHome();
    console.log(extraIPs, 'see extra impact points in confirmation modal');
    return (
        <Overlay>
            <div
                ref={modalRef} // Attach ref to modal content
                className="absolute rounded-lg left-[50%]    bg-grayBgNormal border   translate-x-[-50%] translate-y-[-50%] top-[50%]"
                onClick={(e) => e.stopPropagation()} // Stop propagation to avoid closing the modal when clicked inside
            >
                <>
                    <div className={`p-6  w-[518px]`}>
                        <div className="relative">
                            <button
                                className="  absolute z-[9999] top-0 right-0  rounded-full  "
                                onClick={() => {
                                    close();
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                >
                                    <circle cx="15" cy="15" r="15" fill="#F3F3F3" />
                                    <path
                                        d="M20.5918 10L10.5914 20.0004"
                                        stroke="#B2B2B2"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M20 20L9.99964 9.99964"
                                        stroke="#B2B2B2"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </button>
                        </div>
                        <h1
                            className="text-2xl font-semibold text-tPrimary text-center"
                            style={{
                                textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                            }}
                        >
                            Are you sure you want to <br /> change your primary pill
                        </h1>
                        {extraIPs && (
                            <p className="text-tSecondary text-center text-sm mt-3 ">
                                The {extraIPs} points you have collected will be transferred to the selected NFT.
                            </p>
                        )}

                        <div className="mt-5 flex items-center justify-center gap-4">
                            <button
                                onClick={async () => {
                                    try {
                                        startLoading();

                                        await putSelectedPill(foundPill);
                                        setTimeout(() => {
                                            handleConfirmAction(close, stopLoading);
                                        }, 5000);
                                    } catch (error) {
                                        console.log(error);
                                    } finally {
                                    }
                                }}
                                className=" bg-[#426A61] flex items-center py-3 px-4 justify-center gap-1 text-white border w-[11rem] border-[#699F84] rounded-lg "
                            >
                                {loading ? (
                                    <Loader color="fill-[#326F58]" />
                                ) : (
                                    <>
                                        <span>Yes</span>
                                    </>
                                )}
                            </button>
                            <button
                                className=" bg-[#FFFFFF] flex items-center py-3 px-4 justify-center gap-1 text-tPrimary border border-[#E8E8E8]  w-[11rem] 3A3A3A rounded-lg "
                                onClick={close}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </>
            </div>
        </Overlay>
    );
}

export default PrimaryPillConfirmation;
